import { DisplayLocales, LocalizationModel, VoiceLocales } from '@shared/models/localization/Locales';

export const DefaultDisplayLocale: DisplayLocales = 'en';
export const DefaultVoiceLocale: VoiceLocales = 'en-us';

export const VOICE_LOCALE_FLAGS: Record<string, string> = {
    'en-us': '🇺🇸',
    'en-gb': '🇬🇧',
    'en-in': '🇮🇳',
    es: '🇪🇸',
    fr: '🇫🇷',
    it: '🇮🇹',
    de: '🇩🇪',
    ja: '🇯🇵',
};

export const locales: LocalizationModel = {
    display: ['en', 'es', 'fr', 'it', 'de', 'ja'] satisfies DisplayLocales[],
    voice: ['en-us', 'en-gb', 'en-in', 'es', 'fr', 'it', 'de', 'ja'] satisfies VoiceLocales[],
};

export const dictationCommandsByLocale: { [key in VoiceLocales]: string[] } = {
    'en-us': ['type'],
    'en-gb': ['type'],
    'en-in': ['type'],
    es: ['escribe'],
    fr: ['tape'],
    it: ['scrivi'],
    de: ['schreiben'],
    ja: ['書く'],
};
